"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/patientResponse/PatientMessage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactlinkify = require('react-linkify'); var _reactlinkify2 = _interopRequireDefault(_reactlinkify);

var _Attachment = require('web/components/Conversation/Attachment'); var _Attachment2 = _interopRequireDefault(_Attachment);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _time = require('shared/services/time');
var _mentions = require('shared/services/mentions');
var _uploadFailure = require('shared/services/uploadFailure');




var _thread = require('./thread');


const LINK_PROPERTIES = { target: '_blank', rel: 'noopener noreferrer' }

const MessageText = ({ row }) => (
  _react2.default.createElement(_reactlinkify2.default, { properties: LINK_PROPERTIES, __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}
    /* dir="auto": Arabic or Hebrew text reads right-to-left. */
    , _react2.default.createElement('span', { className: "patient-message--text", dir: "auto", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
      ,  _mentions.splitTextWithMentions.call(void 0, _nullishCoalesce(row.TextContent, () => ( '')), row.Mentions).map(segment => segment.mention
        ? _react2.default.createElement('span', { key: segment.start, className: "message-mention", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}, segment.text)
        : _react2.default.createElement(_react2.default.Fragment, { key: segment.start, __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}, segment.text)) 
    )
  )
)

const MessageFile = ({ row }) => {
  const { FileInfo } = row
  // SAFETY: rows with Metadata are uploaded files, which have a key and the
  // server's metadata shape (an upload's own metadata has the same fields).
  const fileKey = _optionalChain([FileInfo, 'optionalAccess', _ => _.FileKey]) 
  const fetchLinks = _react.useCallback.call(void 0, 
    () => _client2.default.send('GetPatientFileLink', { FileKey: fileKey }).catch(() => null),
    [fileKey],
  )

  if (_optionalChain([FileInfo, 'optionalAccess', _2 => _2.Metadata])) {
    return (
      _react2.default.createElement(_Attachment2.default, {
        ...FileInfo.Metadata ,
        FileKey: fileKey,
        Error: FileInfo.Error,
        ThumbnailURL: FileInfo.ThumbnailURL,
        fetchLinks: fetchLinks, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
      )
    )
  }
  if (_optionalChain([FileInfo, 'optionalAccess', _3 => _3.LocalMetaData, 'optionalAccess', _4 => _4.hasUploadFailed])) {
    return (
      _react2.default.createElement('span', { className: "patient-message--upload-failed", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
        ,  FileInfo.LocalMetaData.isTooLarge
          ? _uploadFailure.UPLOAD_TOO_LARGE_MESSAGE
          : 'The file upload has failed. Please, try again.' 
      )
    )
  }
  return _react2.default.createElement('span', { className: "patient-message--uploading", role: "status", 'aria-label': "Uploading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
}






/* The provider's delivery states (Sending, Not sent · Retry), with "Waiting
 * to send" for a message written offline. A sent message shows nothing. */
const SendStatus = ({ row, onRetry }) => {
  const retry = _react.useCallback.call(void 0, () => onRetry(row), [onRetry, row])

  switch (row.SendState) {
    case 'sending':
      return (
        _react2.default.createElement('div', { className: "patient-message--status", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
          , _react2.default.createElement('span', { className: "patient-message--spinner", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}} )
          , _react2.default.createElement('span', { className: "patient-message--status-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}, "Sending")
        )
      )
    case 'waiting':
      return (
        _react2.default.createElement('div', { className: "patient-message--status", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
          , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}, "schedule"), "Waiting to send"

        )
      )
    case 'failed':
      return (
        _react2.default.createElement('div', { className: "patient-message--status patient-message--status-failed" , role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
          , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}, "error_outline"), "Not sent."

          , _react2.default.createElement('button', { type: "button", className: "patient-message--retry", onClick: retry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}, "Retry")
        )
      )
    default:
      return null
  }
}

// Holding a bubble this long and letting go opens its actions on a phone.
// It opens on release, so the sheet never appears under a finger iOS is
// still using, and not when the press selected text (iOS then cancels the
// touch, or leaves the selection), which stays the browser's.
const LONG_PRESS_MS = 450
const LONG_PRESS_SLOP_PX = 10

/* The quoted message inside a reply; it jumps to the original when the
 * thread has it. */
const Quote = ({ quote, onJump }) => {
  const jump = _react.useCallback.call(void 0, () => onJump(quote.targetKey), [onJump, quote.targetKey])
  const body = (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  quote.name && _react2.default.createElement('span', { className: "patient-message--quote-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}},  quote.name ) 
      , _react2.default.createElement('span', { className: "patient-message--quote-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}},  quote.text )
    )
  )
  return quote.muted
    ? _react2.default.createElement('span', { className: "patient-message--quote patient-message--quote-muted" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}},  body )
    : (
        _react2.default.createElement('button', {
          type: "button",
          className: "patient-message--quote",
          'aria-label': `Go to the message from ${quote.name || 'the clinic'}: ${quote.text}`,
          onClick: jump, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}

          ,  body 
        )
      )
}






const ReactionChip = ({ reaction, onToggle }) => {
  const toggle = _react.useCallback.call(void 0, () => onToggle(reaction.Emoji), [onToggle, reaction.Emoji])
  return (
    _react2.default.createElement('button', {
      type: "button",
      className: _classBuilder2.default.call(void 0, 'patient-message--chip', reaction.Mine && 'patient-message--chip-mine'),
      'aria-pressed': reaction.Mine,
      'aria-label': `${reaction.Emoji} ${reaction.Count}${reaction.Mine ? ', including yours' : ''}`,
      onClick: toggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}}

      , _react2.default.createElement('span', { className: "patient-message--chip-emoji", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}},  reaction.Emoji )
      , _react2.default.createElement('span', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}},  reaction.Count )
    )
  )
}

















const PatientMessage = ({ item, highlighted, actionable, onRetry, onReact, onOpenActions, onJump }) => {
  const { row, mine, senderName, sentAt, runFirst, runLast, quote } = item
  const isFile = !row.TextContent && !!row.FileInfo
  const recalled = _thread.isRecalled.call(void 0, row)
  const bubbleRef = _react.useRef(null)
  const pressRef = _react.useRef(null)

  const toggleReaction = _react.useCallback.call(void 0, (emoji) => onReact(row, emoji), [onReact, row])
  const openMenu = _react.useCallback.call(void 0, (event) => {
    onOpenActions(item, event.currentTarget, false)
  }, [onOpenActions, item])
  const openReactions = _react.useCallback.call(void 0, (event) => {
    onOpenActions(item, event.currentTarget, true)
  }, [onOpenActions, item])

  const cancelPress = _react.useCallback.call(void 0, () => { pressRef.current = null }, [])
  const startPress = _react.useCallback.call(void 0, (event) => {
    const touch = event.touches[0]
    pressRef.current = actionable && touch && event.touches.length === 1
      ? { at: Date.now(), x: touch.clientX, y: touch.clientY }
      : null
  }, [actionable])
  const movePress = _react.useCallback.call(void 0, (event) => {
    const press = pressRef.current
    const touch = event.touches[0]
    if (press && touch && Math.hypot(touch.clientX - press.x, touch.clientY - press.y) > LONG_PRESS_SLOP_PX) cancelPress()
  }, [cancelPress])
  const endPress = _react.useCallback.call(void 0, (event) => {
    const press = pressRef.current
    pressRef.current = null
    if (!press || Date.now() - press.at < LONG_PRESS_MS || !bubbleRef.current) return
    const selection = window.getSelection()
    if (selection && !selection.isCollapsed && bubbleRef.current.contains(selection.anchorNode)) return
    // No click follows, so it can't land on the sheet's scrim.
    event.preventDefault()
    onOpenActions(item, bubbleRef.current, false)
  }, [onOpenActions, item])

  return (
    _react2.default.createElement('div', {
      className: _classBuilder2.default.call(void 0, 'patient-message', {
        'patient-message--mine': mine,
        'patient-message--theirs': !mine,
        'patient-message--run-first': runFirst,
        'patient-message--run-last': runLast,
        'patient-message--failed': row.SendState === 'failed',
        'patient-message--highlight': highlighted,
      }),
      id: String(row.MessageKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}

      , _react2.default.createElement('div', { className: "patient-message--column", __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}}
        ,  runFirst && (
          _react2.default.createElement('div', { className: "patient-message--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}
            ,  senderName && _react2.default.createElement('span', { className: "patient-message--sender", __self: this, __source: {fileName: _jsxFileName, lineNumber: 222}},  senderName ) 
            , _react2.default.createElement('time', { dateTime: sentAt.toISOString(), title: _time.formatLongDisplayDate.call(void 0, sentAt), __self: this, __source: {fileName: _jsxFileName, lineNumber: 223}}
              ,  _time.getDayTimeString.call(void 0, sentAt) 
            )
          )
        )
        , _react2.default.createElement('div', { className: "patient-message--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 228}}
          , _react2.default.createElement('div', {
            ref: bubbleRef,
            className: _classBuilder2.default.call(void 0, 'patient-message--bubble', isFile && 'patient-message--bubble-file'),
            onTouchStart: startPress,
            onTouchMove: movePress,
            onTouchEnd: endPress,
            onTouchCancel: cancelPress, __self: this, __source: {fileName: _jsxFileName, lineNumber: 229}}

            ,  quote && _react2.default.createElement(Quote, { quote: quote, onJump: onJump, __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}} ) 
            ,  recalled
              ? _react2.default.createElement('em', { className: "patient-message--recalled", __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}, "This message was recalled"   )
              : isFile ? _react2.default.createElement(MessageFile, { row: row, __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}} ) : _react2.default.createElement(MessageText, { row: row, __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}} ) 
          )
          ,  actionable && (
            _react2.default.createElement('div', { className: "patient-message--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}}
              , _react2.default.createElement('button', {
                type: "button",
                className: "patient-message--action patient-message--action-react" ,
                'aria-label': "Add reaction" ,
                onClick: openReactions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 244}}

                , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}}, "add_reaction")
              )
              , _react2.default.createElement('button', {
                type: "button",
                className: "patient-message--action patient-message--action-more" ,
                'aria-label': `Message options${senderName ? `, ${senderName}` : ''}`,
                'aria-haspopup': "dialog",
                onClick: openMenu, __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}}

                , _react2.default.createElement('img', { src: "/assets/icons/header/ellipsis-dark.svg", alt: "", width: "24", height: "24", __self: this, __source: {fileName: _jsxFileName, lineNumber: 259}} )
              )
            )
          )
        )
        ,  !!_optionalChain([row, 'access', _5 => _5.Reactions, 'optionalAccess', _6 => _6.length]) && !recalled && (
          _react2.default.createElement('div', { className: "patient-message--chips", __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
            ,  row.Reactions.map(reaction => (
              _react2.default.createElement(ReactionChip, { key: reaction.Emoji, reaction: reaction, onToggle: toggleReaction, __self: this, __source: {fileName: _jsxFileName, lineNumber: 267}} )
            )) 
          )
        )
        ,  mine && _react2.default.createElement(SendStatus, { row: row, onRetry: onRetry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 271}} ) 
      )
    )
  )
}

// The thread rebuilds its items on every change; a row re-renders only when
// its own message, sender or place in a run changed.
const isSameRow = (prev, next) =>
  prev.onRetry === next.onRetry &&
  prev.onReact === next.onReact &&
  prev.onOpenActions === next.onOpenActions &&
  prev.onJump === next.onJump &&
  prev.highlighted === next.highlighted &&
  prev.actionable === next.actionable &&
  _optionalChain([prev, 'access', _7 => _7.item, 'access', _8 => _8.quote, 'optionalAccess', _9 => _9.name]) === _optionalChain([next, 'access', _10 => _10.item, 'access', _11 => _11.quote, 'optionalAccess', _12 => _12.name]) &&
  _optionalChain([prev, 'access', _13 => _13.item, 'access', _14 => _14.quote, 'optionalAccess', _15 => _15.text]) === _optionalChain([next, 'access', _16 => _16.item, 'access', _17 => _17.quote, 'optionalAccess', _18 => _18.text]) &&
  prev.item.row === next.item.row &&
  prev.item.mine === next.item.mine &&
  prev.item.senderName === next.item.senderName &&
  prev.item.runFirst === next.item.runFirst &&
  prev.item.runLast === next.item.runLast

exports. default = _react.memo.call(void 0, PatientMessage, isSameRow)
